


import { FamilyGroup } from './FamilyGroup';
export default FamilyGroup;